import React from 'react';

const IconEmail = ({ className = 'w-5 h-5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path d="M3 6.5A2.5 2.5 0 0 1 5.5 4h13A2.5 2.5 0 0 1 21 6.5v11A2.5 2.5 0 0 1 18.5 20h-13A2.5 2.5 0 0 1 3 17.5v-11z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21 6.5l-9 6-9-6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconLinkedIn = ({ className = 'w-5 h-5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const IconGithub = ({ className = 'w-5 h-5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
  </svg>
);

const ContactCard = ({ href, title, subtitle, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="block p-4 md:p-5 bg-gray-800 border border-transparent rounded-xl shadow-sm hover:shadow-md transform hover:-translate-y-1 transition-all duration-200">
    <div className="flex items-start gap-3 md:gap-4">
      <div className="flex-none w-10 h-10 md:w-12 md:h-12 bg-blue-400 rounded-lg flex items-center justify-center text-black font-semibold">{children}</div>
      <div>
        <div className="text-white font-semibold text-sm md:text-base">{title}</div>
        <div className="text-gray-400 text-xs md:text-sm mt-1">{subtitle}</div>
      </div>
    </div>
  </a>
);

const ContactSection = () => {
  return (
    <section id="contact" className="py-16 md:py-20 bg-gray-900">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-white">Get in touch</h2>
          <div className="w-16 h-1 bg-blue-400 mx-auto mt-4 rounded" />
        </div>

        <div className="max-w-lg mx-auto space-y-4">
          <ContactCard href="mailto:tzy.zhang@mail.utoronto.ca" title="Email" subtitle="tzy.zhang (at) mail.utoronto.ca"><IconEmail className="w-5 h-5 text-black" /></ContactCard>
          <ContactCard href="https://linkedin.com/in/tommyzhng" title="LinkedIn" subtitle="Lets Connect!"><IconLinkedIn className="w-5 h-5 text-black" /></ContactCard>
          <ContactCard href="https://github.com/tommyzhng" title="GitHub" subtitle="View my code"><IconGithub className="w-5 h-5 text-black" /></ContactCard>
        </div>

        <div className="text-center mt-12 pt-8 border-t border-gray-800">
          <p className="text-gray-500 text-sm">© 2025 Tommy Zhang<br/> "What do you mean the website wrote itself??" - Someone from 2021, probably.</p>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
